export const logError = (message: any) => {
    console.error(message);
};
